import React, { useEffect, useState } from "react";
import { useFormik } from "formik";
import { Form, Input } from "semantic-ui-react";
import { useHistory } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { handleNewUserVerification, signOut } from "../../state/auth/actions";
import { handleSignUp } from "../../state/users/actions";
import {
  BoxFormWithHeader,
  LoginContainer,
  Logo,
  InputBlock,
  Label,
  Title,
  Checkers,
} from "./styles";
import Loading from "../../components/LoadingTemplate/index";
import { toastAlert } from "../../components/Toastify/index";
import LogoZaivu from "../../assets/Logo-Zaivu.svg";
import Button from "../../components/general/Button";

const NewAccountPage = ({ match, user }) => {
  const dispatch = useDispatch();
  const history = useHistory();
  const token = useSelector((state) => state.auth.token);
  const [error, setError] = useState(null);
  const resetToken = match.params.token;
  const [validToken, setValidToken] = useState("loading");
  const [enterpriseName, setEnterpriseName] = useState(null);
  const [loading, setLoading] = useState(false);

  const regex = /^(?=.*[A-Z])(?=.*[a-z])(?=.*\d)[A-Za-z\d]{8,}$/;

  useEffect(() => {
    if (token) {
      toastAlert({
        msg: "ERRO: Deslogue da conta antes de abrir o link!",
        isError: true,
      });
      history.push("/");
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [history, token]);

  useEffect(() => {
    dispatch(handleNewUserVerification({ token: resetToken })).then((res) => {
      if (res.payload.error) setValidToken(false);
      else {
        formik.setFieldValue("email", res.payload.email);
        formik.setFieldValue("username", res.payload.username);
        setEnterpriseName(res.payload.enterpriseName);

        setValidToken(true);
      }
    });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const formik = useFormik({
    initialValues: {
      username: "",
      password: "",
      rePassword: "",
    },
    onSubmit: (values) => {
      // Clear Previous Errors
      setError(null);
      setLoading(true);
      dispatch(
        handleSignUp({
          username: values.username,
          password: values.password,
          email: values.email,
        })
      ).then((res) => {
        if (res.type === "ADD_ERROR") {
          setError("Apelido já existente");
        } else {
          toastAlert({ msg: "Conta validada com sucesso!" });
          dispatch(signOut());
          history.push("/login");
        }
        setLoading(false);
      });
    },
  });

  return validToken === true && !loading ? (
    <BoxFormWithHeader>
      <div>
        <Form onSubmit={formik.handleSubmit}>
          <LoginContainer>
            <Logo src={LogoZaivu} />

            <Title>
              Bem vindo à {enterpriseName}, finalize seu cadastro aqui!
            </Title>

            <InputBlock>
              <Label>Email (já escolhido)</Label>
              <Input
                icon="mail"
                iconPosition="left"
                type="email"
                name="email"
                style={{ marginBottom: "10px" }}
                placeholder="Email"
                onChange={formik.handleChange}
                value={formik.values.email}
                disabled
              />
            </InputBlock>
            <InputBlock>
              <Label>Nome de usuário</Label>
              <Input
                icon="user"
                iconPosition="left"
                type="text"
                style={{ marginBottom: "10px" }}
                name="username"
                placeholder="Nome de usuário"
                onChange={formik.handleChange}
                value={formik.values.username}
              />
            </InputBlock>
            <InputBlock>
              <Label>Senha</Label>
              <Input
                icon="lock"
                iconPosition="left"
                type="password"
                style={{ marginBottom: "10px" }}
                name="password"
                placeholder="Senha"
                onChange={formik.handleChange}
                value={formik.values.password}
              />
            </InputBlock>
            <InputBlock>
              <Label>Confirmar senha</Label>
              <Input
                icon="lock"
                iconPosition="left"
                type="password"
                name="rePassword"
                style={{ marginBottom: "10px" }}
                placeholder="Confirmar senha"
                onChange={formik.handleChange}
                value={formik.values.rePassword}
              />
            </InputBlock>

            <Checkers check={formik.values.username}>
              Por favor, escolha um nome de usuário.
            </Checkers>
            <Checkers check={regex.test(formik.values.password)}>
              Senha deve ter no mínimo 8 caracteres, conter pelo menos uma letra
              maiúscula, uma letra minúscula e um número
            </Checkers>
            <Checkers
              check={formik.values.password === formik.values.rePassword}
            >
              as novas senhas devem ser iguais
            </Checkers>
            {error ? (
              <p
                style={{
                  color: "red",
                  alignSelf: "center",
                  marginBottom: "10px",
                  marginTop: "20px",
                }}
              >
                {error}
              </p>
            ) : null}

            <Button
              type="submit"
              disabled={
                !formik.values.username ||
                !formik.values.password ||
                !formik.values.rePassword ||
                !regex.test(formik.values.password) ||
                formik.values.rePassword !== formik.values.password
              }
              content={"Confirmar"}
            />
          </LoginContainer>
        </Form>
      </div>
    </BoxFormWithHeader>
  ) : validToken === false && !loading ? (
    <BoxFormWithHeader>
      <div>Convite inválido ou expirado</div>
    </BoxFormWithHeader>
  ) : (
    <div>
      <Loading />
    </div>
  );
};

export default NewAccountPage;
